<label *ngIf="label && !isButton && !isContextMenu" class="control-label {{customClass}}" [class.disabled]="disabled" [class.required]="isRequired">
    {{label}}
  </label>
  <div (click)="toggleDropDown($event)"
       (appClickOutside)="close()" class="container">
    <div
      [class.dropdown--disabled]="isDisabled"
      [class.dropdown--focused]="opened"
      [class.dropdown--error]="isError"
      class="dropdown">
      <div class="dropdown__value">
        <div  class="dropdown__value__label">
          <span *ngIf="!showStatus && !customSelected && !isButton" [class.placeholder]="!value" appEllipsisTooltip="">{{ placeholder}}</span>
          <span *ngIf="!showStatus && !customSelected && isButton">{{label}}</span>
          <span *ngIf="showStatus && !customSelected && !isButton"  appEllipsisTooltip=""><app-status customSelected [status]="placeholder"></app-status></span>
          <ng-content select="[customSelected]"></ng-content>
        </div>
      </div>
      <span class="dropdown__arrow {{opened ? 'icon-arrow-up-8' : 'icon-arrow-down-8'}}">
    </span>
    </div>
    <div *ngIf="opened"
         class="options-list-wrapper"
         [class.options-list-wrapper--with-label]="!!label">
      <div class="options-list" >
        <ng-content ></ng-content>
      </div>
    </div>
  </div>
  <div class="error-msg" *ngIf="showError">{{errorMessage}}</div>
  